const ROUTES = {
  HOME: "/",
  THANK_YOU: "/thank-you",
};

export { ROUTES };
